import { apiClient } from 'api'
import { Game } from 'types/games'
import { League } from 'types/leagues'
import { Team } from 'types/teams'
import { Stage } from 'types/stage'

export type BracketSlot = {
    id: number
    leagueId: number
    stageId: number
    slotIndex: number
    gameId: number | null
    teamId: number | null
    stage?: Stage
    game?: Game | null
    team?: Team | null
}

export type BracketResponse = {
    league: League
    slots: BracketSlot[]
    unassignedGames: Game[]
}

export type AssignBracketSlotPayload = {
    gameId?: number | null
    teamId?: number | null
}

export const getBracket = (leagueId: number) => apiClient.get<BracketResponse>(`/brackets/${leagueId}`)

export const assignBracketSlot = (leagueId: number, slotId: number, payload: AssignBracketSlotPayload) =>
    apiClient.put<AssignBracketSlotPayload, BracketResponse>(`/brackets/${leagueId}/slots/${slotId}`, payload)
